<template>
  <div>
    <Header title="学生名单查询" type="0" route="/homeIndex"></Header>
    <div class="studentInfoIndex">
      <div class="list-head">
        <div>
          <p>学年学期</p>
          <span @click="showPop('学年学期', 'xnxq')">
            <i>{{ xnxq.mc }}</i>
            <b></b>
          </span>
        </div>
        <div></div>
      </div>
      <div class="indexList">
        <NOdata
          v-if="this.dataList && this.dataList.length == 0"
          title="未查询到成绩信息"
        ></NOdata>
        <div class="list">
          <div
            class="list-item info"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div class="content">
              <p>{{ item.kcmc }}</p>
              <ul>
                <li>通知单号：{{ item.jx0404id }}</li>
                <li>课程号：{{ item.kch }}</li>
                <li>课序号：{{ item.kxh }}</li>
                <li>上课班级：{{ item.ktmc }}</li>
                <li>课表展示名称：{{ item.kbzsmc }}</li>
              </ul>
            </div>
            <div class="operate">
              <span class="ckxsClass" @click="info(item)">选课名单</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";

export default {
  data() {
    return {
      active: 0,
      show: false,
      dataList: [],
      historyList: [],
      xnxq: {},
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: ""
      }
    };
  },
  created() {
    this.getXnxqList();
  },
  methods: {
    info(item) {
      this.$router.push({
        path: "/studentInfo/info",
        query: {
          jx0404id: item.jx0404id
        }
      });
    },

    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;

      this.getList(value[0].value);
    },
    async getXnxqList() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getXnxq();
      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              this.xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
              this.getList(item.xnxq01id);
            }
            return {
              value: item.xnxq01id,
              text: item.xqmc
            };
          }),
          defaultIndex: this.xnxqDefaultIndex
        }
      ];
    },
    async getList(xnxqdm) {
      let xnxqDefaultIndex = 0;
      const res = await Api.getjstzd({
        xnxq01id: xnxqdm
      });
      this.dataList = res.data;

      for (let item of this.historyList) {
        if (item.shzt == "审核中") {
          item.class = "shzClass";
        } else if (item.shzt == "不通过") {
          item.class = "btgClass";
        } else if (item.shzt == "通过") {
          item.class = "ytgClass";
          item.shzt = "已通过";
        } else if (item.shzt == "待送审") {
          item.class = "dssClass";
        }
      }
    }
  }
};
</script>
<style lang="less">
.studentInfoIndex {
  .list-head {
    height: 80px;
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    padding: 6% 7%;
    box-sizing: border-box;
    margin-bottom: 5%;
    margin-left: 20px;
    margin-right: 20px;

    div {
      width: 50%;
      height: 100%;
      p {
        font-size: 12px;
        color: #fff;
        font-weight: lighter;
        margin-bottom: 2%;
      }
      span {
        display: flex;
        align-items: center;
        i {
          font-style: normal;
          font-size: 14px;
          color: #fff;
          margin-right: 5%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 70%;
        }
        b {
          display: inline-block;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-top: 3px solid #fff;
        }
      }
    }
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .indexList {
    padding: 5% 5% 0;
    .van-search {
      padding: 0;
      height: 44px;
      background: #f4f5ff;
      border-radius: 3px;
      margin-bottom: 5%;
    }
    .van-search .van-cell,
    .van-search__content,
    .van-field__control {
      background: #f4f5ff;
    }

    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }

    .list {
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        position: relative;
        .content {
          width: 100%;
          padding: 3% 0 3% 6%;
          p {
            height: 22px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #212f6e;
            letter-spacing: 0;
            margin-bottom: 2%;
          }
          ul li {
            height: 17px;
            font-family: PingFangSC-Light;
            font-size: 12px;
            color: #757da3;
            letter-spacing: 0;
            margin-bottom: 1%;
          }
        }
      }
    }
  }
  .info {
    & .content > span {
      width: 70px;
      height: 42px;
      background: #ecedfd;
      border-radius: 5px;
      position: absolute;
      top: calc(50% - 21px);
      right: 5%;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #7469f8;
      letter-spacing: 0;
      line-height: 15px;
      i {
        font-style: normal;
        font-family: PingFangSC-Light;
        font-size: 10px;
        color: #7469f8;
        letter-spacing: 0;
        font-weight: lighter;
      }
    }
    .operate {
      border-top: 1px solid #dee1e9;
      display: block;
      height: 40px;
      line-height: 40px;
      display: flex;
      width: 100%;
      .ewmClass {
        color: #757da3;
      }
      .ckxsClass {
        color: #7469f8;
      }
      span {
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
        &:first-child {
          border-right: 1px solid #dee1e9;
        }
      }
    }
  }
  .update span {
    height: 20px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    letter-spacing: 0;
    position: absolute;
    top: calc(50% - 10px);
    right: 5%;
    font-weight: bolder;
  }
  .shzClass {
    color: #7469f8;
  }
  .btgClass {
    color: #f86969;
  }
  .ytgClass {
    color: #12ddd6;
  }
  .dssClass {
    color: #757da3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/studentInfo/index.vue